import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  getDashboardAppliedFilters,
  getDashboardViews,
  getDashboardViewsAwaitingResults,
} from '@/store-selectors';
import { refreshDashboard } from '@/actions';
import { useAppDispatch } from '@/store/hooks';

const EVERY_5_MINUTES = 5 * 60 * 1000;

export const RefreshTimer: React.FC = () => {
  const dispatch = useAppDispatch();

  const hasViews = !!useSelector(getDashboardViews);
  const noAppliedFilters = useSelector(getDashboardAppliedFilters).length === 0;
  const noViewsAwaitingResults =
    useSelector(getDashboardViewsAwaitingResults).length === 0;

  useEffect(() => {
    const refreshTimer = setInterval(() => {
      if (hasViews && noAppliedFilters && noViewsAwaitingResults) {
        dispatch(refreshDashboard(false));
      }
    }, EVERY_5_MINUTES);
    return () => {
      clearTimeout(refreshTimer);
    };
  }, [hasViews, noAppliedFilters, noViewsAwaitingResults]);

  return null;
};
